import * as React from 'react';

import {Button} from '../button/button';

import type {Item} from './types';

import styles from './bulk-select-button.module.css';

type Props = {
    selectableItemsList: Item[] | null | undefined;
    onClick: (isSelectingAll: boolean) => void;
};

export function BulkSelectButton(props: Props) {
    const numSelectedItems = props.selectableItemsList
        ? props.selectableItemsList.filter((item) => item.isChecked).length
        : 0;

    // Determines whether all items will be selected or unselected when the button is clicked
    const isSelectingAll = numSelectedItems === 0;

    const shouldShowButton = props.selectableItemsList && props.selectableItemsList.length > 3;

    return (
        <div className={styles.container}>
            {shouldShowButton ? (
                <Button
                    variant='text-primary'
                    noPadding={true}
                    // @ts-expect-error
                    onClick={() => props.onClick(isSelectingAll)}
                >
                    {isSelectingAll ? 'Select all' : 'Unselect All'}
                </Button>
            ) : undefined}
        </div>
    );
}
